// Profile of Alina Tselinina, Finnish. Source of the profile page.
module.exports = {
  headline: 'AI / Software Engineer • Python, R & AWS',
  summary: 'Alina Tselinina on ohjelmistoinsinööri, jolla on tausta datainsinöörityössä, soveltavassa matematiikassa ja koneoppimisessa ja joka työskentelee nykyisin tekoälypohjaisten sovellusten ja agenttisten järjestelmien parissa. Hänellä on kokemusta rajapintojen ja datalinjastojen rakentamisesta, sovellusten modernisoinnista pilvimigraation avulla sekä koneoppimiseen perustuvien palvelujen kehittämisestä. Hänen painopisteensä on yhdistää LLM-mallit ja tekoälyagentit luotettaviin ohjelmistojärjestelmiin jäsennellyillä työnkuluilla, integraatioilla, testauksella ja iteratiivisella arvioinnilla.',
  imageAlt: 'Alina Tselininan muotokuva',
  personal: {
    languages: 'Englanti, puola',
    programmingLanguages: 'Python, R, SQL, Bash'
  },
  education: [
    {
      period: '2014 - 2017',
      field: 'Opinnot: finanssi- ja vakuutusmatematiikka',
      institution: 'Adam Mickiewiczin yliopisto, Poznań',
      degree: 'Tutkinto: maisteri'
    },
    {
      period: '2009 - 2014',
      field: 'Opinnot: matematiikka',
      institution: 'Valko-Venäjän valtionyliopisto, Minsk',
      degree: 'Tutkinto: kandidaatti'
    }
  ],
  skills: [
    {
      title: 'Ohjelmointi',
      description: 'Python, R, SQL, Bash'
    },
    {
      title: 'Tekoäly ja LLM-mallit',
      description: 'Claude, MCP, tekoälyagentit, LLM-mallien mukauttaminen, mallien koulutus ja arviointi'
    },
    {
      title: 'Pilvi ja data',
      description: 'AWS (Lambda, EC2, S3, Glue, RDS, Athena, Step Functions), Snowflake'
    },
    {
      title: 'Kehykset ja rajapinnat',
      description: 'FastAPI, Flask, Shiny, REST-rajapinnat, Swagger, JSON Schema, Jinja, lxml'
    },
    {
      title: 'Datainsinöörityö ja DevOps',
      description: 'ETL, Airflow, Docker, Git, Linux, CI/CD'
    },
    {
      title: 'Tietokannat ja orkestrointi',
      description: 'PostgreSQL, Camunda'
    },
    {
      title: 'Atlassian-työkalut',
      description: 'Jira, Bitbucket, Confluence'
    }
  ],
  positions: [
    {
      period: 'Maaliskuusta 2026 alkaen',
      title: 'AI / Software Engineer, pAIoneer Labs',
      description: [
        'Tekoälyagenttien kehitys, työnkulkujen määritys ja työkaluintegraatiot.',
        'LLM-mallien mukauttaminen sekä mallien koulutus ja arviointi.',
        'Tekoälypohjaisten sovellusten kehitys ja integrointi.',
        'Kvanttilaskenta: osallistuminen kvanttisovellusten ohjelmistokehitykseen.'
      ]
    },
    {
      period: 'Toukokuusta 2025 alkaen',
      title: 'Senior Software Developer, Geninvo',
      description: [
        'Sovelluskehitys.',
        'Yksikkötestien ja käyttöliittymätestien toteutus sovelluksen laadun tukemiseksi.'
      ]
    },
    {
      period: 'Marraskuu 2022 - helmikuu 2025',
      title: 'Senior Python Developer, T-Systems',
      description: [
        'Datalinjastojen ja työnkulkujen orkestroinnin ylläpito ja parantaminen.',
        'Pakettien kehitys raportoinnin automatisointiin.'
      ]
    },
    {
      period: 'Heinäkuu 2022 - lokakuu 2022',
      title: 'Data Engineer, S&P Global',
      description: [
        'ETL-linjastojen kehitys ja ylläpito.'
      ]
    },
    {
      period: 'Maaliskuu 2022 - kesäkuu 2022',
      title: 'Python Developer, DevBridge',
      description: [
        'REST-rajapintojen ja taustajärjestelmäpalvelujen suunnittelu ja kehitys.',
        'JSON-dataa käsittelevän taustajärjestelmälogiikan toteutus.'
      ]
    },
    {
      period: 'Marraskuu 2020 - maaliskuu 2022',
      title: 'Senior Software Developer, Roche',
      description: [
        'REST-rajapintojen ja taustajärjestelmäpalvelujen suunnittelu ja kehitys (konseptitodistus).',
        'ETL-linjastojen kehitys ja ylläpito.',
        'Paikallisten (on-premise) sovellusten modernisointi AWS-migraation ja R-koodin Python-uudelleenkirjoituksen avulla.',
        'XML-validointi ja muunnos HTML:ksi.',
        'Verkkosovellusten kehitys.'
      ]
    },
    {
      period: 'Toukokuu 2020 - marraskuu 2020',
      title: 'Data Scientist, PSI Polska, Poznań',
      description: [
        'REST-rajapintojen ja taustajärjestelmäpalvelujen suunnittelu ja kehitys koneoppimismallilla taustajärjestelmässä.',
        'Asiakassegmentointimallin kehitys.'
      ]
    },
    {
      period: 'Tammikuu 2019 - huhtikuu 2020',
      title: 'Advanced Data Scientist, Analyx, Poznań',
      description: [
        'Verkkoharavointi (web scraping) ja dataputkien kehitys.',
        'Verkkosovellusten kehitys.',
        'Markkinointimixin mallinnus.',
        'Työnkulkujen optimointi.'
      ]
    },
    {
      period: 'Toukokuu 2018 - joulukuu 2018',
      title: 'Data Scientist, Poznań',
      description: [
        'ETL-prosessin kehitys.',
        'Bash-skriptien ylläpito.',
        'Asiakastuki ja ad hoc -analyysit.'
      ]
    },
    {
      period: 'Huhtikuu 2017 - huhtikuu 2018',
      title: 'Junior Analyst, Poznań',
      description: [
        'Data-analyysi ja raporttien laatiminen.',
        'Dokumentaation ja esitysten laatiminen.'
      ]
    }
  ]
};
